import React, { useEffect, useRef, useState } from "react";
import { api } from "../../lib/api";

export const usePageImages = (tpl) => {
  const [urls, setUrls] = useState([]);
  useEffect(() => {
    if (!tpl?.id) { setUrls([]); return undefined; }
    let alive = true;
    const made = [];
    Promise.all(tpl.pages.map((_, i) => api.get(`/moduli-template/${tpl.id}/page/${i}`, { responseType: "blob", params: { v: tpl.updated_at }, timeout: 45000 })
      .then(({ data }) => { const u = URL.createObjectURL(data); made.push(u); return u; }).catch(() => "")))
      .then((u) => { if (alive) setUrls(u); });
    return () => { alive = false; made.forEach((u) => URL.revokeObjectURL(u)); };
  }, [tpl?.id, tpl?.updated_at, tpl?.pages?.length]); // eslint-disable-line react-hooks/exhaustive-deps
  return urls;
};

export const FIELD_LABELS = { text: "Testo", date: "Data", checkbox: "Casella", signature_tecnico: "Firma sopralluoghista", signature_cliente: "Firma cliente" };
export const FIELD_COLORS = { text: "#1565C0", date: "#6A1B9A", checkbox: "#2E7D32", signature_tecnico: "#E65100", signature_cliente: "#C62828" };

export const SignaturePad = ({ title, onSave, onClose, saving }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio); ctx.lineWidth = 2.6; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0b1f5c";
  }, []);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); setEmpty(false); };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-3" style={{ background: "rgba(0,0,0,.55)" }} data-testid="signature-pad">
      <div className="bg-white rounded-xl w-full max-w-2xl p-4">
        <div className="font-bold mb-2">{title}</div>
        <div className="text-xs mb-2" style={{ color: "var(--text-muted)" }}>Firma con il dito o con la penna nel riquadro.</div>
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up}
          className="w-full h-56 rounded-lg border-2 border-dashed touch-none bg-white" style={{ borderColor: "#94a3b8" }} data-testid="signature-canvas" />
        <div className="flex justify-between mt-3 gap-2">
          <button onClick={clear} className="btn-secondary" data-testid="signature-clear">Cancella</button>
          <div className="flex gap-2">
            <button onClick={onClose} className="btn-secondary" data-testid="signature-cancel">Annulla</button>
            <button onClick={() => onSave(ref.current.toDataURL("image/png"))} disabled={empty || saving} className="btn-primary disabled:opacity-50" data-testid="signature-save">Salva firma</button>
          </div>
        </div>
      </div>
    </div>
  );
};
